// extracted by mini-css-extract-plugin
export default {"blockLoader":"BlockLoader_blockLoader__JEvB9","loading":"BlockLoader_loading__Arkq2"};